import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import logo from '../assets/logo1.jpeg';
import mubarkLogo from '../assets/Mubark.jpeg';
import './Footer.css';

export function Footer() {
    const { t, language } = useLanguage();
    const isRtl = language === 'ar';
    const [showWA, setShowWA] = useState(false);
    const waRef = useRef(null); // Ref لحاوية الواتساب

    // إغلاق القائمة عند النقر خارجها
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (waRef.current && !waRef.current.contains(event.target)) {
                setShowWA(false);
            }
        };

        // نستمع للنقرات في جميع أنحاء المستند
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside); // دعم للهواتف

        // تنظيف الحدث عند فك المكون
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    return (
        <footer className="footer-sysora-agency" dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="footer-elite-wrap">
                <div className="footer-main-grid">
                    
                    {/* AL MUBARAK BRANDING */}
                    <div className="footer-col brand-col-elite">
                        <img src={logo} alt="Ayonk" className="footer-ayonk-top" />
                        <div className="group-elite-identity">
                            <span className="group-prefix-gold">{isRtl ? 'إحدى شركات مجموعة' : 'A Member of'}</span>
                            <h2 className="group-name-large">{isRtl ? 'ال مبارك جروب' : 'Al Mubarak Group'}</h2>
                            {/* Fixed Image Card */}
                            <div className="mubarak-logo-card">
                                <img src={mubarkLogo} alt="Al Mubarak Group" className="mubarak-img-actual" />
                            </div>
                        </div>
                    </div>

                    {/* NAVIGATION */}
                    <div className="footer-col">
                        <h4 className="footer-title-red">{isRtl ? 'الشركة' : 'Company'}</h4>
                        <ul className="footer-nav-links">
                            <li><Link to="/">{t('nav.home')}</Link></li>
                            <li><Link to="/about">{t('nav.about')}</Link></li>
                            <li><Link to="/portfolio">{t('nav.projects')}</Link></li>
                            <li><Link to="/testimonials">{isRtl ? 'آراء العملاء' : 'Testimonials'}</Link></li>
                        </ul>
                    </div>

                    {/* SERVICES */}
                    <div className="footer-col">
                        <h4 className="footer-title-red">{isRtl ? 'خدماتنا' : 'Services'}</h4>
                        <ul className="footer-nav-links">
                            <li><Link to="/services">{isRtl ? 'أعمال التشطيب' : 'Finishing'}</Link></li>
                            <li><Link to="/services">{isRtl ? 'التصميم الداخلي' : 'Interior'}</Link></li>
                            <li><Link to="/services">{isRtl ? 'الإنشاءات' : 'Construction'}</Link></li>
                            <li><Link to="/services">{isRtl ? 'واجهات خارجية' : 'Facades'}</Link></li>
                        </ul>
                    </div>

                    {/* CONTACTS - MATHEMATICALLY SYMMETRICAL */}
                    <div className="footer-col contacts-elite">
                        <h4 className="footer-title-red">{isRtl ? 'تواصل معنا' : 'Contact'}</h4>
                        <div className="phone-premium-box">
                            <a href="tel:01022267372" dir="ltr">01022267372</a>
                            <a href="tel:01140411941" dir="ltr">01140411941</a>
                        </div>

                        {/* Button Stack */}
                        <div className="action-buttons-wrapper">
                            
                            {/* WHATSAPP RECTANGLE - Add Ref here */}
                            <div className="wa-dropdown-container" ref={waRef}>
                                <button className="elite-action-btn wa-btn" onClick={() => setShowWA(!showWA)}>
                                    <MessageCircle size={22} />
                                    <span>WhatsApp</span>
                                    <ChevronDown size={18} className={showWA ? 'wa-open' : ''} />
                                </button>
                                {showWA && (
                                    <div className="wa-dropdown-box">
                                        <a href="https://wa.me/201028989353" target="_blank" rel="noreferrer" dir="ltr">01028989353</a>
                                        <a href="https://wa.me/201273148393" target="_blank" rel="noreferrer" dir="ltr">01273148393</a>
                                    </div>
                                )}
                            </div>

                            {/* INSTAGRAM RECTANGLE */}
                            <a href="https://instagram.com/ayonk.designs" target="_blank" rel="noreferrer" className="elite-action-btn insta-btn">
                                <Instagram size={22} />
                                <span>Instagram</span>
                            </a>

                        </div>
                    </div>

                </div>

                {/* SYSORA AGENCY SIGNATURE BAR */}
                <div className="footer-agency-bar">
                    <p className="footer-copy">© {new Date().getFullYear()} Ayonk. All rights reserved.</p>
                    <div className="sysora-power-marketing">
                        <span className="sys-label">{isRtl ? 'تصميم وتطوير' : 'Developed by'}</span>
                        <a href="https://www.linkedin.com/company/sysoraeg/" target="_blank" rel="noreferrer" className="sysora-agency-link">
                            SYSORA
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
